import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Avatar, Badge, Card, Col, List, Modal, Row, Spin, Typography } from "antd";
const { Title } = Typography;
import QueueAnim from "rc-queue-anim";
// import { Pie } from "@ant-design/plots";

import moment from "moment";

import { dashboardService } from "./../../redux/services";
import DonutChart from "../../components/Charts/DonutChart";
import LineStats from "../../components/Charts/LineStats";
import BarChartBankHours from "../../components/Charts/BarChartBankHours";
import StatCard from "../../components/StatCard";

const customColors = ['#FFD700', '#FF7F7F ', '#00CED1 ', '#8A2BE2 ', '#32CD32 '];

let chartConfig = {
	appendPadding: 10,
	data: [],
	angleField: 'value',
	colorField: 'type',
	radius: 1,
	innerRadius: 0.6,
	height: 300,
	label: {
		type: 'inner',
		offset: '-50%',
		content: '{value}',
		style: {
			textAlign: 'center',
			fontSize: 0,
		},
	},
	theme: {
		colors10: customColors,
	},
	interactions: [
		{
			type: 'element-selected',
		},
		{
			type: 'element-active',
		},
	],
	// 	legend: {
	// 		position: MOBILE && "top"
	// 	},
};

const equipamento_labels = {
	'REP-P': 'Aplicativo',
	'REP-C': 'Equipamento',
}

class Home extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			functionaios_limite: 0,
			funcionarios_ativos: 0,
			funcionarios_inativos: 0,
			funcionarios_ausentes: 0,
			total_funcionarios: 0,
			ultimo_registros: [],
			status_conexao: {},
			departamentos_ativos: 0,
			hoursChat: [],
			cardData: [],
			banco_horas: [],
			horas_extras: [],
			empresas_ativas: 0,
			aniversariantes_total: 0,
			aniversariantes_lista: [],
			total_feriados: 0,
			proximo_feriado: "00/00/0000",
			admissao_demissao: [],
			presentes: 0
		};
	}

	componentDidMount() {
		// Fecth all
		this.fetchGetAll();
	};

	fetchGetAll = () => {
		this.setState({
			isLoading: true,
		});

		dashboardService.getAll()
			.then((response) => {
				const { data } = response.data || {};

				const cardData = [
					{
						value: "3/5",
						title: "Empresas e filiais",
						subtitle: "Média de funcionários: 33,33",
						gradientFrom: "from-fuchsia-600",
						gradientTo: "to-pink-500"
					}
				];

				const toDate = (isoString) => {
					return new Date(isoString);
				};

				this.setState({
					isLoading: false,
					functionaios_limite: data.functionaios_limite ?? 0,
					funcionarios_ativos: data.funcionarios_ativos ?? 0,
					funcionarios_inativos: data.funcionarios_inativos ?? 0,
					funcionarios_ausentes: data.funcionarios_ausentes ?? 0,
					total_funcionarios: data.total_funcionarios ?? 0,
					ultimo_registros: data.ultimo_registros ?? [],
					departamentos_ativos: data.departamentos_ativos ?? "",
					status_conexao: data.status_conexao ?? {},
					cardData: cardData ?? [],
					banco_horas: data.banco_horas ?? [],
					horas_extras: data.horas_extras ?? [],
					empresas_ativas: data.empresas_ativas ?? 0,
					aniversariantes_total: data.funcionarios_aniversariantes.total ?? 0,
					aniversariantes_lista: data.funcionarios_aniversariantes.lista ?? [],
					total_feriados: data.feriados.total_feriados ?? 0,
					proximo_feriado: data.feriados.proximo_feriado ? toDate(data.feriados.proximo_feriado).toLocaleDateString() : "00/00/0000",
					admissao_demissao: data.admissao_demissao ?? [],
					presentes: data.presentes ?? 0

				});
			})
			.catch((data) => {
				this.setState({
					isLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	greeting = () => {
		const hour = moment().hour();
		let day = "Bom dia";

		if (hour >= 19) {
			day = "Boa noite";
		}
		else if (hour >= 12) {
			day = "Boa tarde";
		}

		return `Olá ${this.props.user.name}, ${day}!`;
	};

	handleGetAvatarUrl = (basePathAvatar) => {
		return `${process.env.MIX_API_EMPRESA_URL}/${basePathAvatar}`
	}

	render() {
		const {
			isLoading,
			functionaios_limite,
			funcionarios_ativos,
			funcionarios_inativos,
			departamentos_ativos,
			ultimo_registros,
			hoursChat,
			banco_horas,
			horas_extras,
			empresas_ativas,
			aniversariantes_total,
			aniversariantes_lista,
			total_feriados,
			proximo_feriado,
			admissao_demissao,
			presentes
		} = this.state;

		chartConfig = {
			...chartConfig,
			data: presentes,
		}

		return (
			<QueueAnim className="site-content-inner page-home alternative-wrapper">
				<div className="page-content" key="1">
					{isLoading ? (
						<div className="text-center">
							<Spin indicator={<i className="fad fa-spinner-third fa-spin fa-3x" />} />
						</div>
					) : (
						<Fragment>
							<Row gutter={16} align="stretch">
								<Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={5} flex="1" style={{ paddingBottom: 15 }}>
									<StatCard
										value={empresas_ativas}
										title="Empresas"
										icon="alert"
										onClick={() => { }}
										backgroundColor="#e734a6"
									/>
								</Col>
								<Col xs={24} sm={12} lg={8} xxl={5} flex="1" style={{ paddingBottom: 15 }}>
									<StatCard
										value={departamentos_ativos}
										title="Departamentos"
										icon="vector"
										onClick={() => { }}
										backgroundColor="#fac309"
									/>
								</Col>
								<Col xs={24} sm={8} lg={6} xxl={5} flex="1" style={{ paddingBottom: 15 }}>
									<StatCard
										value={`${funcionarios_ativos}/${functionaios_limite}`}
										title="Funcionários"
										caption={`Limite: ${functionaios_limite} / Ativos: ${funcionarios_ativos} /  Inativo: ${funcionarios_inativos}`}
										icon="vector-user"
										onClick={() => { }}
										backgroundColor="#0cc0fc"
									/>
								</Col>
								<Col xs={24} sm={8} lg={6} xxl={5} flex="1" style={{ paddingBottom: 15 }}>
									<StatCard
										value={aniversariantes_total}
										title="Aniversariantes"
										icon="like"
										onClick={() => { }}
										backgroundColor="#4cc399"
										lista={aniversariantes_lista}
										openOn="click"
									/>
								</Col>
								<Col xs={24} sm={8} lg={6} xxl={5} flex="1" style={{ paddingBottom: 15 }}>
									<StatCard
										value={total_feriados}
										title="Feriados"
										caption={`Próximo: ${proximo_feriado}`}
										icon="api"
										onClick={() => { }}
										backgroundColor="#033244"
									/>
								</Col>
							</Row>
							<Row gutter={16} align="stretch">
								<Col xs={24} sm={24} lg={12} xxl={10} style={{ paddingBottom: 15 }}>
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
										<Typography.Title level={5} style={{ margin: 0 }}>
											Estatísticas dos últimos 30 dias
										</Typography.Title>
										{this.props.permissions.includes("gestao.ponto-diario") ?
											<Typography.Link style={{ fontSize: 14 }} onClick={() => { this.props.history.push("/gestao/dailypoint") }}>
												Ver Histórico completo <i className="fas fa-chevron-right"></i>
											</Typography.Link>
											:
											<Typography.Link style={{ fontSize: 14, visibility: "hidden" }}>
												&nbsp;
											</Typography.Link>
										}
									</div>
									<Card data-has-link={false}>
										<DonutChart data={presentes} />
									</Card>
								</Col>
								<Col xs={24} sm={24} lg={12} xxl={14} style={{ paddingBottom: 15 }}>
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
										<Typography.Title level={5} style={{ margin: 0 }}>&nbsp;</Typography.Title>
										<Typography.Link style={{ fontSize: 14 }}>
											&nbsp;
										</Typography.Link>
									</div>
									<Card data-has-link={false}>
										<LineStats/>
									</Card>
								</Col>
							</Row>
							<Row gutter={16} align="stretch">
								<Col xs={24} sm={12} lg={12} xxl={10}>
									<Typography level={5} style={{ margin: 0 }}>&nbsp;</Typography>
									<Card data-has-link={false}>
										<BarChartBankHours endPoint="banco_horas" valueKey="horas_total" title="Estatísticas de Banco de Horas" subtitle="Esse mês" />
									</Card>
								</Col>
								<Col xs={24} sm={12} lg={12} xxl={14}>
									<Typography level={5} style={{ margin: 0 }}>&nbsp;</Typography>
									<Card data-has-link={false}>
										<BarChartBankHours endPoint="horas_extras" valueKey="horas_total" title="Estatísticas de Hora Extra" subtitle="Esse mês" />
									</Card>
								</Col>
							</Row>
							<Row gutter={{ xs: 24 }} align="top" style={{ marginTop: 30 }}>
								<Col xs={24}>
									<Typography.Title level={5} style={{ margin: 0 }}>
										Últimos Registros
									</Typography.Title>

									<List
										rowKey={(item) => item.id ?? `${item.data}-${item.funcionario?.nome}`}
										dataSource={ultimo_registros}
										renderItem={(item) => (
											<List.Item /* sem marginRight aqui */
												style={{ padding: 0, flex: '0 0 auto' }}
											>
												<div className="register-card">
													<div style={{ flex: "0 0 auto" }}>
														{item?.funcionario?.avatar ? (
															<Avatar src={item.funcionario.avatar} size={32} />
														) : (
															<i className="fad fa-user-circle avatar-placeholder"
																style={{ fontSize: 32, color: "#b3b3b3" }} />
														)}
													</div>
													<div style={{ minWidth: 0 }}>
														<div className="register-date">
															{moment(item.data).format("DD/MM/YYYY HH:mm[h]")}
														</div>
														<div className="register-name" title={item.funcionario?.nome}>
															{item.funcionario?.nome}
														</div>
														<div style={{ fontSize: 12, paddingTop: 4, color: "#667085" }}>
															{item.equipamento?.tipo_equipamento || "N/A"}
														</div>
													</div>
												</div>
											</List.Item>
										)}
									/>
								</Col>
							</Row>
						</Fragment>
					)}
				</div>
			</QueueAnim >
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		user: state.auth.userData,
		permissions: state.auth.userData.permissions,
	};
};

export default connect(mapStateToProps)(Home);
